/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespCollectionsComponents_user$ref = any;
export type SbRespCollectionsModules_user$ref = any;
export type SbRespCollectionsModules_user = {
    readonly " $fragmentRefs": SbRespCollectionsComponents_user$ref;
    readonly " $refType": SbRespCollectionsModules_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCollectionsModules_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbRespCollectionsComponents_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'e1ddf31a066173dddc0b89b41bec86d3';
export default node;
